import storage from 'store'
import expirePlugin from 'store/plugins/expire'

storage.addPlugin(expirePlugin)
const tabs = {
  state: {
    currentTab: undefined,
    tabs: [
      {
        name: '工作台',
        code: 'WorkHomeIndex'
      }
    ],
    iframeList: []
  },

  mutations: {
    SET_CURRENT_TAB: (state, tab) => {
      state.currentTab = tab
    },
    SET_TABS: (state, tabs) => {
      state.tabs = tabs
    },
    SET_IFRAME_LIST: (state, iframeList) => {
      state.iframeList = iframeList
    },
  },

  actions: {

    // 添加标签页
    AddTab ({ commit, state }, currentTab) {
      return new Promise((resolve) => {
        if (currentTab.code !== 'WorkHomeIndex') {
          const currentTabs = state.tabs.filter(tab => currentTab.code === tab.code)
          if (currentTabs.length > 0) {
            commit('SET_CURRENT_TAB', currentTabs[0])
          } else {
            commit('SET_CURRENT_TAB', currentTab)
            commit('SET_TABS', [...state.tabs, currentTab])
          }

        }
        if (currentTab.url) {
          const currentIframes = state.iframeList.filter(iframe => currentTab.code === iframe.code)
          if (currentIframes.length === 0) {
            commit('SET_IFRAME_LIST', [...state.iframeList, currentTab])
          }
        }

        resolve()
      })
    },

    ActiveTab({ commit, state }, currentTab) {
      return new Promise((resolve) => {
        const currentTabs = state.tabs.filter(tab => currentTab === tab.code)
        if (currentTabs.length > 0) {
          commit('SET_CURRENT_TAB', currentTabs[0])
        }
        resolve()
      })
    },

    DeleteTab({ commit, state }, currentTab) {
      return new Promise((resolve) => {
        const notCurrentTabs = state.tabs.filter(tab => currentTab !== tab.code)
        const currentIframeList = state.iframeList.filter(iframe => currentTab !== iframe.code)
        commit('SET_TABS', notCurrentTabs)
        commit('SET_CURRENT_TAB', notCurrentTabs[0])
        commit('SET_IFRAME_LIST', currentIframeList)
        resolve()
      })
    }

  }
}

export default tabs
